import React from "react";
import { render } from "react-dom";
import { HashRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { getFontConfig } from "@helpers/fontConfig";
import { loadConfiguredFont } from "@helpers/fontLoader";
import initLogger from "@helpers/logging";

import { App } from "./App";
import "./assets/css/fonts.css";
import "./i18n";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/600.css";
import "@fontsource/roboto/700.css";

initLogger();

// Defer non-critical font download until after first paint. Pass the resolved
// font name so fontLoader skips the getComputedStyle reflow on startup.
type IdleCallbackHandle = number;
type IdleDeadline = { didTimeout: boolean; timeRemaining(): number };
type WindowWithIdle = typeof window & {
    requestIdleCallback?: (
        cb: (deadline: IdleDeadline) => void,
        opts?: { timeout: number }
    ) => IdleCallbackHandle;
};
const scheduleFontLoad = () => {
    const fontName = getFontConfig().font;
    const w = window as WindowWithIdle;
    if (typeof w.requestIdleCallback === "function") {
        w.requestIdleCallback(() => loadConfiguredFont(fontName), {
            timeout: 2000,
        });
    } else {
        window.setTimeout(() => loadConfiguredFont(fontName), 0);
    }
};

render(
    <React.StrictMode>
        <HashRouter>
            <App />
        </HashRouter>
        <ToastContainer />
    </React.StrictMode>,
    document.getElementById("root")
);

scheduleFontLoad();
